import React from 'react'

const BeneficiaryTableShimmerEffect = ({title}) => {
  return (
    <>
      <div className={'govdash-tableHeader'}>
        <h2 className={'govdash-sectionTitle'}>{title}</h2>
        <button
          disabled={true}
          className={'govdash-exportBtn'}
          title="Download Excel"
        >
          <i className="fas fa-file-excel"></i> Export to Excel
        </button>
      </div>
      <div className="govdash-tableWrapper">
        <table className="govdash-table">
          <thead>
            <tr>
              <th>
                <span className="table-shimmer" style={{ width: '20px', height: '14px', display: 'block' }}></span>
              </th>
              <th>
                <span className="table-shimmer" style={{ width: '60px', height: '14px', display: 'block' }}></span>
              </th>
              <th>
                <span className="table-shimmer" style={{ width: '70px', height: '14px', display: 'block' }}></span>
              </th>
              <th>
                <span className="table-shimmer" style={{ width: '65px', height: '14px', display: 'block' }}></span>
              </th>
            </tr>
          </thead>
          <tbody>
            {/* 6 shimmer rows */}
            {Array(6).fill().map((_, i) => (
              <tr key={`table-row-shimmer-${i}`}>
                <td>
                  <span className="table-shimmer" style={{ width: '50px', height: '16px', display: 'block' }}></span>
                </td>
                <td>
                  <span className="table-shimmer" style={{ width: '140px', height: '16px', display: 'block' }}></span>
                </td>
                <td>
                  <span className="table-shimmer" style={{ width: '90px', height: '16px', display: 'block' }}></span>
                </td>
                <td>
                  <span className="table-shimmer" style={{ width: '110px', height: '16px', display: 'block' }}></span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  )
}

export default BeneficiaryTableShimmerEffect
